export default __webpack_public_path__ + "static/media/minerva-explanation.8a7f7058.gif";